import { Parameters, RequestContext } from '../types/request-context';
import { Logger } from '../logger/logger';

export const parseQueryParams = (parameters: Parameters = {}) => {
    const parsedParams: any = {};
    Object.keys(parameters).forEach((param) => {
        parsedParams[param] = parameters[param].value;
    });
    return parsedParams;
};

export const constructUrlEncodedString = (logger: Logger, currentParams: object = {}, newParams: object = {}) => {
    let queryArray: string[] = [];
    const query = { ...currentParams, ...newParams };
    Object.entries(query).forEach(([key, value]) => {
        if (typeof value === 'string') {
            queryArray.push(`${key}=${encodeURIComponent(value)}`);
        } else if (typeof value === 'number') {
            queryArray.push(`${key}=${value}`);
        } else if (typeof value === 'boolean') {
            queryArray.push(`${key}=${value ? '1' : '0'}`);
        } else if (Array.isArray(value)) {
            value.forEach((item) => {
                queryArray.push(`${key}=${encodeURIComponent(item)}`);
            });
        } else if (value == undefined) {
            queryArray.push(`${key}=`);
        } else {
            logger.error(`Cannot convert ${key} with value ${value} to query string`);
        }
    });
    return queryArray.join('&');
};

export const constructQueryString = (logger: Logger, currentParams: object = {}, newParams: object = {}) => {
    const urlEncodedString = constructUrlEncodedString(logger, currentParams, newParams);
    return `?${urlEncodedString}`;
};

type TakeArray = 'first' | 'last'

export const queryParameterExists = (context: RequestContext, key: string) => context.queryParameters.hasOwnProperty(key)

export const queryParameterValue = (context: RequestContext, key: string, take: TakeArray = 'last'): string => {
    const values: string[] = context.queryParameters[key]
    if (values !== undefined && values.length > 0) {
        return take === 'first' ? values[0] : values[values.length - 1]
    }
    return undefined
}
